<template>
  <div>
    <entry-message-sent-date
      :date="date"
      :is-read="isRead"
    />
    <entry-message-subject :subject="subject" />
    <entry-message-body
      :body="body"
      :is-remind-mail="isRemindMail"
    />
  </div>
</template>

<script>
import EntryMessageSentDate from '@/components/atoms/EntryMessageSentDate'
import EntryMessageSubject from '@/components/atoms/EntryMessageSubject'
import EntryMessageBody from '@/components/atoms/EntryMessageBody'

export default {
  components: {
    EntryMessageSentDate,
    EntryMessageSubject,
    EntryMessageBody
  },
  props: {
    date: {
      type: String,
      default: ''
    },
    isRead: {
      type: Boolean,
      default: null
    },
    subject: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: ''
    },
    isRemindMail: {
      type: Boolean,
      default: false
    }
  }
}
</script>
